import { useContext } from "react";
import Link from "next/link";
import Image from "next/image";

import { FiPlus, FiMinus, FiTrash2 } from "react-icons/fi";

//internal import
import { SidebarContext } from "@context/SidebarContext";
import { CartContext } from "@context/CartContext";

const CartItem = ({ item, checkoutPage, status }) => {
  const { closeCartDrawer } = useContext(SidebarContext);
  const { updateItemQuantity, removeItem } = useContext(CartContext);
  return (
    <div className="group w-full h-auto flex justify-start items-center bg-white py-2 sm:py-3 px-2 sm:px-4 border-b hover:bg-gray-50 transition-all border-gray-100 relative last:border-b-0">
      {/* Product Image */}
      <div className="relative flex rounded-lg border border-gray-200 shadow-sm overflow-hidden flex-shrink-0 mr-2 sm:mr-4 transition-transform duration-300">
        <Image
          key={item.id}
          src={item.image}
          width={50}
          height={50}
          alt={item.title}
          placeholder="blur"
          blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          style={{
            maxWidth: "100%",
            height: "auto"
          }}
          className="object-cover w-12 h-12 sm:w-15 sm:h-15 md:w-16 md:h-16"
        />
      </div>
      {/* Product Details */}
      <div className="flex flex-col w-full overflow-hidden">
        <div className="flex justify-between items-start">
          {/* Product Title and Lubrication Service Info */}
          <div className="max-w-[65%] sm:max-w-[70%]">
            <Link
              href={`/product/${item.slug}`}
              title={item.title}
              onClick={closeCartDrawer}
              className="text-xs sm:text-sm text-gray-700 hover:text-red-600 transition-colors duration-300 line-clamp-2">
              {item.title}
            </Link>

            {/* Lubrication Service text moved below title */}
            {item.addOnPrice !== 0 && (
              <div className="text-xs text-red-500 font-serif mt-0.5">
                + Lubrication Service
              </div>
            )}
          </div>

          {/* Product Price - Discounted or Regular */}
          <div className="text-right">
            {item.itemSubTotal !== item.itemTotal ? (
              // Show both prices with strikethrough when discounted
              <div>
                <span className="text-xs text-gray-500 line-through">৳{item.itemSubTotal}</span>
                <div className="text-xs sm:text-sm font-semibold text-red-600">৳{item.itemTotal}</div>
              </div>
            ) : (
              // Show just one price when no discount
              <span className="text-xs sm:text-sm font-semibold text-gray-800">৳{item.itemSubTotal}</span>
            )}
          </div>
        </div>
        <div className="flex items-center justify-between mt-1 sm:mt-2">
          {/* Quantity Control */}
          <div className="h-6 sm:h-8 flex flex-wrap items-center justify-evenly border border-gray-200 bg-white text-gray-600 rounded-full shadow-sm">
            {checkoutPage && (
              <button
                className={`w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center rounded-full ${item.quantity <= 1
                    ? "text-gray-300 cursor-not-allowed"
                    : "text-gray-600 hover:bg-gray-100 hover:text-red-500"
                  }`}
                disabled={
                  status === "inStock" ? item.quantity <= 1 && true : false
                }
                onClick={() =>
                  updateItemQuantity(
                    item.baseAddonPrice,
                    item.id,
                    item.quantity - 1,
                    status
                  )
                }
              >
                <span className="text-xs sm:text-base">
                  <FiMinus />
                </span>
              </button>
            )}

              <p className="text-xs sm:text-sm font-medium text-gray-700 px-1 sm:px-2 min-w-[24px] sm:min-w-[30px] text-center flex justify-center items-center">
                {item.quantity} x ৳{item.price + item.baseAddonPrice}
              </p>



            {checkoutPage && (
              <button
                className="w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center rounded-full text-gray-600 hover:bg-gray-100 hover:text-red-500"
                onClick={() =>
                  updateItemQuantity(
                    item.baseAddonPrice,
                    item.id,
                    item.quantity + 1,
                    status
                  )
                }
              >
                <span className="text-xs sm:text-base">
                  <FiPlus /> 
                </span>
              </button>
              
            )}
          </div>

          {/* Delete Button */}
          {checkoutPage && (
            <button
              onClick={() =>
                removeItem(item.id, item.quantity, status, item.oldQty)
              }
              className="hover:text-red-600 text-gray-400 hover:bg-red-50 w-6 h-6 sm:w-8 sm:h-8 rounded-full flex items-center justify-center transition-colors duration-300"
            >
              <FiTrash2 className="text-sm sm:text-lg" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartItem;
